export default "__VITE_ASSET__DiJi2goJ__"